// EstimationChargesDetails.tsx
import React from 'react';
import { Text, View } from '@upstox/upstox-ui';
import Divider from 'assets/divider.svg';
// services
import LocaleService from 'modules/Localization';
// typings
import { EstimationChargesDetailsProps } from '../EstimatedCharges/typings';
// styles
import * as css from './styles';

const EstimationChargesDetails:
  React.FC<EstimationChargesDetailsProps> = (
    { chargesData },
  ) => (
    <React.Fragment>
      <View css={css.chargesDescription}>
        <View css={css.topDivider}>
          <img src={Divider} alt="divider" />
        </View>
        <View css={css.chargesList}>
          <Text size="s" color="text.2">{LocaleService.translate('BROKERAGE_CHARGES')}</Text>
          <Text size="s" weight="bold">₹ {chargesData.brokerage}</Text>
        </View>
        <View css={css.chargesList}>
          <Text size="s" color="text.2">{LocaleService.translate('CHARGES_AND_TAXES')}</Text>
          <Text size="s" weight="bold">₹ {chargesData.chargesAndTaxes}</Text>
        </View>
        <View css={css.chargesList}>
          <Text size="s" color="text.2">{LocaleService.translate('CHARGES')}</Text>
          <Text size="s" weight="bold">₹ {chargesData.charges}</Text>
        </View>
        <View css={css.chargesList}>
          <Text size="s" color="text.2">{LocaleService.translate('TAXES')}</Text>
          <Text size="s" weight="bold">₹ {chargesData.taxes}</Text>
        </View>
      </View>
      <View>
        <img src={Divider} alt="divider" />
      </View>
      <View css={css.disclaimer}>
        <Text size="s" weight="bold" lineHeight="s">{LocaleService.translate('DISCLAIMER_TITLE')}
          <span style={css.disclaimerText}>
            <Text size="s" color="text.2" lineHeight="s">
              {LocaleService.translate('CHARGES_CALCULATION_DISCLAIMER')}
            </Text>
          </span>
        </Text>
      </View>
    </React.Fragment>
);

export default EstimationChargesDetails;
